module.exports = __webpack_public_path__ + "media/images/icons/icon_driving-faeb78d08a21384e5fe0796b165cd680.svg";